import { CaseModel } from './case.model';
import { DocumentModel } from './document.model';

export interface DocumentActionModel {
  action: string;
  document?: DocumentModel;
  case?: CaseModel;
  filename?: string;
}

export const DocumentActionOpen: string = 'Open';
export const DocumentActionOpenNewTab: string = 'OpenNewTab';
export const DocumentActionNew: string = 'New';
export const DocumentActionSave: string = 'Save';
export const DocumentActionSaveAs: string = 'SaveAs';
export const DocumentActionPrint: string = 'Print';
export const DocumentActionDownload: string = 'Download';
export const DocumentActionDownloadAsPdf: string = 'DownloadAsPdf';
export const DocumentActionUpload: string = 'Upload';
export const DocumentActionLogout: string = 'Logout';
export const DocumentActionClose: string = 'Close';
